export default "__VITE_ASSET__Czc3mrNM__"